import { type ComponentProps, type ReactNode } from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { X } from 'lucide-react'
import { DialogPortal } from './portal'
import { DialogBackdrop } from './backdrop'
import { DialogPopup } from './popup'
import { DialogClose } from './close'

interface DialogContentProps {
  className?: string
  backdropClassName?: string
  children: ReactNode
  showClose?: boolean
  initialFocus?: ComponentProps<typeof BaseDialog.Popup>['initialFocus']
}

export function DialogContent({
  className,
  backdropClassName,
  children,
  showClose = true,
  initialFocus,
}: DialogContentProps) {
  return (
    <DialogPortal>
      <DialogBackdrop className={backdropClassName} />
      <DialogPopup className={className} initialFocus={initialFocus}>
        {showClose && (
          <DialogClose
            aria-label="Close dialog"
            shape="circle"
            size="xs"
            // z-20 keeps the button hit-testable above dialog chrome that
            // stacks itself (headers) — those overlap this corner and would
            // otherwise swallow the click.
            className="absolute right-4 top-4 z-20 flex"
            variant="secondary"
          >
            <X className="size-3 stroke-[length:var(--icon-stroke-width-bold)]" />
          </DialogClose>
        )}
        {children}
      </DialogPopup>
    </DialogPortal>
  )
}
